import { useEffect, useState } from 'react';

export const useTextOverflow = <T extends HTMLElement = HTMLDivElement>(
  text?: string
) => {
  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const [element, setElement] = useState<T | null>(null);

  useEffect(() => {
    if (!element) return undefined;

    const calculateTextOverflow = () => {
      const { scrollWidth, clientWidth, scrollHeight, clientHeight } = element;

      setIsTextOverflowing(
        scrollWidth > clientWidth || scrollHeight > clientHeight
      );
    };

    const observer = new ResizeObserver(calculateTextOverflow);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, text]);

  return { isTextOverflowing, textRef: setElement };
};
